import React from 'react';
import LoginForm from './LoginForm';

function App() {
  return (
    <div>
      <LoginForm />
    </div>
  );
}

export default App;
